/* eslint-disable no-undef */

interface Config {
    backendUrl?: string,
    firebase: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
        measurementId: string;
    },
    routes?: any,
    dashboardItems: any,
    waveTypeOptions: any,
    roundingTypeOptions: any,
    smoothingTypeOptions: any,
    filterTypeOptions: any,
    addLessonOptions: any,
    skillLevel: any,
		courseList: any,
    all: string,
    enrolled: string,
    appDomain: any,
    acceptedFileImageVideo: any,
    monthNames: any,
    acceptedFilesImages: any,
    acceptedFilesVideos: any,
    acceptedImageFormats: any,
    acceptedVideoFormats: any,
    acceptedImageVideoFormats: any
	userTypes: any,
	razorPayKey: string,
	teaserVideo: string,
	landingImageKey: string,
	indoSoulImageKey: string,
	courseId: {
		moduleBasedCourseId: any;
		skillSongCourseId: any;
	};

}

const config: Config = {
	courseId: {
		moduleBasedCourseId: "665468e8f2ef2a75397a820c",
		skillSongCourseId  : "66547261f2ef2a75397a820d"
	},
	backendUrl: process.env.REACT_APP_BACKEND_API_URL || "",
	firebase  : {
		apiKey           : process.env.REACT_APP_FIREBASE_API_KEY || "",
		authDomain       : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
		projectId        : process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
		storageBucket    : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
		messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID || "",
		appId            : process.env.REACT_APP_FIREBASE_APP_ID || "",
		measurementId    : process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
	},
	routes: {
		"landingPage"       : "/",
		"landingHome"       : "/home",
		"login"             : "/login",
		"forgotPassword"    : "/forgot-password",
		"register"          : "/register",
		"course"            : "/course",
		"soundAnalysis"     : "/sound-analysis",
		"userProfile"       : "/user-profile",
		"userAddress"       : "/user-address",
		"editProfile"       : "/edit-user-profile",
		"userIntro"         : "/user-intro",
		"userLevel"         : "/user-level",
		"modules"           : "/modules",
		"moduleIntro"       : "/module-intro",
		"payment"           : "/payment",
		"announcement"      : "/announcement",
		"video"             : "/level-content-by-module",
		"lessons"           : "/admin/list-lessons/add-lessons",
		"listCourse"        : "/admin/list-course",
		"listModules"       : "/admin/list-modules",
		"listLevels"        : "/admin/list-levels",
		"listLessons"       : "/admin/list-lessons",
		"dashboard"         : "/admin-dashboard",
		"addModulePage"     : "/admin/add-module",
		"addLevelPage"      : "/admin/add-level",
		"editCourse"        : "/admin/list-course/edit-course",
		"termsAndConditions": "/terms-and-conditions",
		"refundPolicy"      : "/refund-policy",
		"privacyPolicy"     : "/privacy-policy",
		"addPost"           : "/add-post",
		"purchaseHistory"   : "/purchase-history"
		
	},
	dashboardItems: [
		{
			id         : 1,
			title      : "POC",
			description: "POC For Sound Analysis.",
			path       : "/sound-analysis"
		}
	],
	waveTypeOptions: [
		{
			value: "Sine Wave",
			label: "sine"
		},
		{
			value: "Frequency Bars",
			label: "bars"
		}
	],
	roundingTypeOptions: [
		{
			value: "Note",
			label: "note"
		},
		{
			value: "HZ",
			label: "hz"
		},
		{
			value: "None",
			label: "none"
		}
	],
	smoothingTypeOptions: [
		{
			value: "None",
			label: "none"
		},
		{
			value: "Basic",
			label: "basic"
		},
		{
			value: "Very",
			label: "very"
		}
	],
	filterTypeOptions: [
		{
			value: "Bandpass",
			label: "bandpass"
		},
		{
			value: "Lowpass",
			label: "lowpass"
		},
		{
			value: "Highpass",
			label: "highpass"
		},
		{
			value: "Lowshelf",
			label: "lowshelf"
		},
		{
			value: "Highshelf",
			label: "highshelf"
		},
		{
			value: "Peaking",
			label: "peaking"
		},
		{
			value: "Notch",
			label: "notch"
		},
		{
			value: "Allpass",
			label: "allpass"
		}
	],
	addLessonOptions: [
		{
			value: "Skills and Songs",
			label: "skill and songs"
		},
		{
			value: "Module Based Learning",
			label: "Module Based Learning"
		}
	],
	skillLevel: {
		"firstTimer": "firstTimer", "beginner": "beginner", "intermediate": "intermediate", "advanced": "advanced"
	},
	courseList: {
		"selfPaced": "Module Based Learning", "songsAndSkill": "Skills And Songs"
	},
	all      : "all",
	enrolled : "enrolled",
	appDomain: process.env.REACT_APP_DOMAIN,

    
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	],
	acceptedFilesImages   : { "image/png": [], "image/jpeg": [], "image/jpg": [] },
	acceptedFilesVideos   : { "video/mp4": [], "video/quicktime": [], "video/x-msvideo": [] },
	acceptedFileImageVideo: {
		"image/png"      : [],
		"image/jpeg"     : [],
		"image/jpg"      : [],
		"video/mp4"      : [],
		"video/quicktime": [],
		"video/x-msvideo": []
	},
	acceptedImageFormats: [
		"image/png",
		"image/jpeg",
		"image/jpg"
	],
	acceptedVideoFormats: [
		"video/mp4",
		"video/mkv",
		"video/webm",
		"video/quicktime"
	],
	acceptedImageVideoFormats: [
		"image/jpeg",
		"image/jpg",
		"image/png",
		"video/mp4",
		"video/mkv",
		"video/webm"
	],
	userTypes: {
		"systemAdmin": "systemAdmin",
		"user"       : "user",
		"student"    : "student",
		"teacher"    : "teacher"
	},
	razorPayKey     : process.env.REACT_APP_RAZORPAY_KEY || "",
	teaserVideo     : "public/landing-page/SoulSwara Teaser.mp4",
	landingImageKey : "public/landing-page/images/",
	indoSoulImageKey: "public/indosoul/"
    
};

export default config;
